// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__gsz3N","productName":"Table_productName__3Em2r"};